// Google Ads conversion tracking. Legacy parity: TrialUpgrade.component.tsx
// injected these AW event snippets after a completed trial upgrade.
const GOOGLE_ADS_TAG_ID = 'AW-1071865117';

const CONVERSION_SEND_TO = {
  premiumPurchase: `${GOOGLE_ADS_TAG_ID}/neevCPKUqfUBEJ26jf8D`,
  standardPurchase: `${GOOGLE_ADS_TAG_ID}/K5KTCKeRqfUBEJ26jf8D`,
} as const;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export class GoogleAds {
  /**
   * Report a trial-upgrade purchase conversion to Google Ads. Premium plans
   * (no stream limit) and standard plans report to different conversion
   * actions. Production builds only — dev conversions would corrupt campaign
   * metrics. Never throws: ad blockers commonly remove gtag, and analytics
   * must not break the upgrade flow.
   */
  static trackTrialUpgradeConversion(isPremiumPlan: boolean): void {
    if (!import.meta.env.PROD) return;
    try {
      GoogleAds.ensureLoaded();
      window.gtag?.('event', 'conversion', {
        send_to: isPremiumPlan
          ? CONVERSION_SEND_TO.premiumPurchase
          : CONVERSION_SEND_TO.standardPurchase,
      });
    } catch {
      // Swallow — see doc comment.
    }
  }

  /** Inject the gtag stub + loader once; events queue in dataLayer until gtag.js loads. */
  private static ensureLoaded(): void {
    if (window.gtag) return;
    window.dataLayer = window.dataLayer ?? [];
    // gtag.js requires the Arguments object on the dataLayer, not an array —
    // hence a function expression instead of an arrow with rest params.
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer?.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', GOOGLE_ADS_TAG_ID);

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_TAG_ID}`;
    document.head.appendChild(script);
  }
}
